<template>
  <div class="index-wrap">
    <div class="hidden-sm-and-up index-head-min">
      <el-row class="title">
        <el-col :xs="8" :sm="8">
          <router-link to="/home" @click.stop>
            <img class="logo" src="../assets/logo.png" />
          </router-link>
        </el-col>
        <el-col :xs="16" :sm="16" class="icon">
          <i
            class="fa fa-bars"
            aria-hidden="true"
            @click="isOpen = !isOpen"
            :class="{ open: !isOpen }"
          ></i>
          <i
            class="fa fa-times"
            aria-hidden="true"
            @click="isOpen = !isOpen"
            :class="{ open: isOpen }"
          ></i>
        </el-col>
      </el-row>
      <div :class="{ open: isOpen }" class="head-content">
        <template v-if="isLogin">
          <router-link to="/user" class="item" @click.native="isOpen = false">
            <span><i class="fa fa-user"></i>个人信息</span>
          </router-link>
          <div
            class="item"
            @click="
              isOpen = false;
              logOutVisible = true;
            "
          >
            <span><i class="fa fa-sign-out"></i>退出</span>
          </div>
        </template>
        <template v-else>
          <div
            class="item"
            @click="
              loginActiveName = 'login';
              toLogin = true;
            "
          >
            登录
          </div>
          <div
            class="item"
            @click="
              loginActiveName = 'register';
              toLogin = true;
            "
          >
            注册
          </div>
        </template>
      </div>
    </div>
    <div class="modal" :class="{ open: isOpen }" @click="isOpen = false"></div>

    <div class="hidden-xs-only index-head">
      <div class="index-container" style="display: flex">
        <div class="index-head-max">
          <router-link to="/home">
            <span class="company-name"
              ><img class="logo" src="../assets/logo.png"
            /></span>
          </router-link>
        </div>
        <div
          class="fr"
          style="
            display: flex;
            place-content: center flex-start;
            align-items: center;
            flex-direction: row;
            flex: auto;
            justify-content: flex-end;
          "
        >
          <template v-if="isLogin">
            <span class="item">你好，{{ userInfo.chName }}</span>
            <router-link to="/user" class="item"
              ><span><i class="fa fa-user"></i>个人信息</span></router-link
            >
            <router-link to="/order" class="item"
              ><span><i class="fa fa-list-alt"></i>订单记录</span></router-link
            >
            <a class="item" href="https://u129zjwxfro.feishu.cn/wiki/L7M0wqS9biHC2NkjXp8cA1EcnIf" target="_blank"
              ><span><i class="fa fa-question-circle"></i>考试常见Q&A</span></a
            >
            <router-link to="/renewal" class="item"
              ><span><i class="fa fa-refresh"></i>证书维持</span></router-link
            >
            <router-link to="/certificate" class="item"
              ><span><i class="fa fa-trophy"></i>证书查询</span></router-link
            >
            <!--                        <el-dropdown class="item" trigger="click">-->
            <!--                            <span >更多功能<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i></span>-->
            <!--                            <el-dropdown-menu slot="dropdown">-->
            <!--                                <el-dropdown-item style="font-weight: 600; color: #00549f"><router-link to="/order" class="item">订单记录</router-link></el-dropdown-item>-->
            <!--                                <el-dropdown-item style="font-weight: 600; color: #00549f"><router-link to="/renewal" class="item">证书维持</router-link></el-dropdown-item>-->
            <!--                                <el-dropdown-item style="font-weight: 600; color: #00549f"><router-link to="/cpeApply" class="item">CPE申报</router-link></el-dropdown-item>-->
            <!--                                <el-dropdown-item style="font-weight: 600; color: #00549f"><router-link to="/cpeActivity" class="item">CPE活动</router-link></el-dropdown-item>-->
            <!--                            </el-dropdown-menu>-->
            <!--                        </el-dropdown>-->
            <div class="item" @click="logOutVisible = true">
              <span><i class="fa fa-sign-out"></i>退出</span>
            </div>
          </template>
          <template v-else>
            <a class="item" href="https://u129zjwxfro.feishu.cn/wiki/L7M0wqS9biHC2NkjXp8cA1EcnIf" target="_blank"
              ><span><i class="fa fa-question-circle"></i>考试常见Q&A</span></a
            >
            <router-link to="/renewal" class="item"
              ><span><i class="fa fa-refresh"></i>证书维持</span></router-link
            >
            <router-link to="/certificate" class="item"
              ><span><i class="fa fa-trophy"></i>证书查询</span></router-link
            >
            <el-button
              @click="
                loginActiveName = 'login';
                toLogin = true;
              "
              size="small"
              >登录</el-button
            >
            <el-button
              @click="
                loginActiveName = 'register';
                toLogin = true;
              "
              size="small"
              >注册</el-button
            >
          </template>
        </div>
      </div>
      <div class="header-line">
        <div class="header-box"></div>
        <div class="header-box2"></div>
      </div>
    </div>
    <el-dialog title="温馨提示" :visible.sync="logOutVisible" width="80%">
      <p class="dialog-content">确认退出系统</p>
      <div slot="footer" class="dialog-footer">
        <el-button @click="logOutVisible = false">取 消</el-button>
        <el-button type="primary" @click="logOut()">确 定</el-button>
      </div>
    </el-dialog>
    <div class="index-body">
      <router-view></router-view>
    </div>
    <div class="footer">
      <span>电话：{{ systemConfig.telPhone }}</span
      >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <span>微信：{{ systemConfig.wechat }}</span
      >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <span>邮箱：{{ systemConfig.email }}</span
      ><br />
      <span>Copyright© 2018.云安全联盟大中华区&nbsp;All rights reserved</span
      ><br />
      <span>粤ICP备16001302号-1</span>
    </div>
    <el-dialog title="登录" :visible.sync="toLogin" class="login-content">
      <v-login
        :currentName="loginActiveName"
        :closeDialogLogin="!toLogin"
      ></v-login>
    </el-dialog>
  </div>
</template>

<script>
import login from "./login.vue";
import Bus from "../bus.js";
export default {
  components: {
    "v-login": login,
  },
  data: function () {
    return {
      isOpen: false,
      logOutVisible: false,
      toLogin: false,
      loginActiveName: "login",
    };
  },
  computed: {
    userInfo: function () {
      return this.$store.state.userInfo;
    },
    systemConfig: function () {
      return this.$store.state.systemConfig;
    },
    isLogin: function () {
      return this.$store.state.userInfo && this.$store.state.userInfo.chName
        ? true
        : false;
    },
  },
  methods: {
    logOut() {
      this.$axios
        .get("/logout")
        .then((response) => {
          this.$store.commit("updateUserInfo", null);
          sessionStorage.removeItem("userInfo");
          window.location.reload();
        })
        .catch((error) => {
          this.$store.commit("updateUserInfo", null);
          sessionStorage.removeItem("userInfo");
          window.location.reload();
        });
    },
  },
  mounted() {
    Bus.$on("toOpenLigon", (val) => {
      this.toLogin = val;
      this.$nextTick(() => {
        this.loginActiveName = "login";
      });
    });
    Bus.$on("changeTab", (val) => {
      this.loginActiveName = val;
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/deep/ .login-content .el-dialog__header {
  display: none;
}
/deep/ .login-content .el-dialog__body {
  padding: 0;
}
.index-head-min .item {
  margin: 0 15px;
  font-size: 14px;
  line-height: 50px;
  display: block;
  cursor: pointer;
  color: #00549f;
  border-bottom: 1px solid #e1e1e1;
}
.index-head-min .item:last-child {
  border-color: transparent;
}
.index-head-min .icon {
  text-align: right;
  line-height: 50px;
  color: #999;
  font-size: 25px;
  padding-right: 15px;
  cursor: pointer;
  position: relative;
}
.fa {
  margin-right: 4px;
}

.index-head-min .icon .fa {
  opacity: 0;
}
.index-head-min .icon .fa.open {
  opacity: 1;
  position: absolute;
  right: 15px;
  top: 12.5px;
}
.index-head-min .title {
  border-bottom: 1px solid #e1e1e1;
}
.index-head-min {
  position: fixed;
  top: 0;
  width: 100%;
  overflow: hidden;
  z-index: 9;
  background: #fff;
}
.head-content,
.modal {
  transition: opacity 0.3s ease;
}
.head-content {
  height: 0;
}
.modal {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  opacity: 0;
  height: 0;
  z-index: 8;
  background: #000;
}
.head-content.open {
  height: auto;
}

.modal.open {
  height: 100%;
  opacity: 0.5;
}

.footer {
  background: #f2f2f2;
  line-height: 30px;
  padding: 30px 0 20px 0;
  text-align: center;
  font-size: small;
  color: #000;
}
.header-line {
  position: relative;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.header-box,
.header-box2 {
  display: inline-block;
  width: 50%;
  background: #e98300;
  height: 20px;
  vertical-align: middle;
}
.header-box2 {
  background: #00549f;
}

a {
  text-decoration: none;
  display: inline-block;
}
.index-head {
  width: 100%;
  top: 0;
  z-index: 9;
  position: fixed;
  background: #fff;
}
.logo {
  height: 90px;
  display: inline-block;
  vertical-align: middle;
}

.index-wrap .index-head-max {
  height: 90px;
  line-height: 90px;
}
.index-wrap .index-body {
  height: 100%;
  padding: 90px 0;
}

.index-wrap .index-container {
  margin-left: auto;
  margin-right: auto;
  max-width: 960px;
}

.company-name {
  color: #00549f;
  font-weight: 600;
  font-size: medium;
}

.fr {
  float: right;
}
.item {
  font-size: 14px;
  font-weight: 600;
  display: inline-block;
}
.fr .item {
  text-align: center;
  color: #00549f;
}
.fr .item + .item {
  margin-left: 30px;
  cursor: pointer;
}
.fr .item + button,
.fr button + button {
  margin-left: 30px;
}
.index-wrap {
  padding-top: 50px;
}
@media screen and (min-width: 768px) and (max-width: 990px) {
  .index-wrap .index-head-max {
    padding: 0 20px;
  }
}
@media screen and (max-width: 767px) {
  .footer span {
    padding: 20px 0 10px 0;
    font-size: 12px;
  }
  .index-wrap {
    padding-top: 50px;
  }
  .logo {
    padding-left: 4px;
    height: 44px;
  }
  .index-wrap .index-body {
    padding-top: 0;
  }
  /deep/.login-content .el-dialog {
    max-width: 450px;
    width: 100%;
  }

  /deep/.login-content .login-card {
    width: calc(100% - 80px) !important;
  }
}
</style>